module.exports = __webpack_public_path__ + "static/img/icon_grxxtx40.03d51f41.svg";